import React from 'react';
import {
  withRestrictedModal,
  WithRestrictedModalProps,
} from '../../../../../components/modal/components/modal-restricted/withRestrictedModal';
import { withUser } from '../../../../../user/UserContext';
import { doctrineAnalytics } from '../../../../../utils/analyticsUtils';
import { makeLawEventData } from './legislationSnippetUtils';
import styles from './legislation_content.module.scss';
import { StateType } from '../../../../../state/state.types';
import { UserContextType } from '../../../../../user/user.types';

type Props = {
  law: NonNullable<StateType['results']['snippets']['law']>;
} & WithRestrictedModalProps &
  UserContextType;

type State = {
  open: boolean;
};

class RawLegislationContent extends React.Component<Props, State> {
  state: State = { open: false };

  toggle = () => {
    const { accessPremium, law, openRestrictedModal } = this.props;

    if (accessPremium) {
      const { open } = this.state;
      if (!open) {
        doctrineAnalytics('Search LawExpanded', {
          ...makeLawEventData(law),
          reportOriginalQueryKey: true,
        });
      }
      this.setState(state => ({ open: !state.open }));
    } else {
      openRestrictedModal('search_law');
    }
  };

  render() {
    const { law } = this.props;
    const { open } = this.state;
    return (
      <div className={styles.text}>
        <div
          dangerouslySetInnerHTML={{
            __html: open ? law.text : law.textShort,
          }}
        />
        {law.text !== law.textShort && (
          <span className={styles.display} onClick={this.toggle}>
            {!open ? 'Afficher la suite' : 'Afficher moins'}
          </span>
        )}
      </div>
    );
  }
}

export const LegislationContent = withUser(
  withRestrictedModal(RawLegislationContent),
);
